import { stringify } from "query-string";
import { useContext } from "react";
import { useEffect, useState } from "react";
import fetchApi from "../../../api/fetchApi";
import { Context } from "../../../App";
import Fancybox from "../../../Components/Fancybox/Fancybox";
import './CurrentRoom.scss';

const types = {
    "flat": "кв",
    "office": "оф",
    "commerce": "оф",
    "parking": "парк",
    "storeroom": "клад",
}

export default function CurrentRoom({currentRoom, setLoading}) {
  const initialProps = useContext(Context);
  const [data, setData] = useState({});
  const [type, setType] = useState("кв");

    const fetchCurrentRoom = async () => {
        setLoading(true);
        const {json, error} = await fetchApi('sale/current_room?'+ stringify({apartment_id: currentRoom.id, facilityId: 79}));
        setData(json.results);
        setLoading(false);
    }

    useEffect(() => {
        fetchCurrentRoom()
        window.scrollTo({
          top: document.querySelector(".room").offsetTop,
          behavior: "smooth"
        })
    }, []);

    useEffect(() => {
        setType(types[data?.type]);
    }, [data]);


    const handlePrint = () => {
        window.print();
    }


    return (
        <>
        <div className="room__item__header">
            <svg class="svg-icon icon-logo print">
                <use xlinkHref="/static/svg/sprite.svg#logo"></use>
            </svg>
            <p>
                Отдел продаж УКС АВИТЕК:<br/>
                <strong>
                    тел. (8332) 730-230 www.uksavitek.ru <br/>
                    Новый офис на ул. Труда, 72а <br/>
                </strong>
            </p>
        </div>
        <div className="room__item current">
            <div className="current__left">
                <div className="current__image">
                    <img src={data.img} alt={data.name} data-fancybox-trigger="object" />
                </div>
                <div className="current__preview-box">
                    {
                        data.thumbs &&
                        data.thumbs.map(thumb => (
                            <Fancybox>
                                <button
                                  data-fancybox="gallery"
                                  data-src={thumb}
                                  className="button button--secondary"
                                >
                                    <img src={thumb} alt="" />
                                </button>
                            </Fancybox>
                        ))
                    }
                </div>
                <a href="/modal_call" className="current__link" data-modal>Хочу здесь жить</a>
                {window.innerWidth > 768 && <button className="current__print" onClick={handlePrint}>Распечатать</button>}
            </div>
        <div className="current__right">
            <div className="current__place">
                <div className="current__body">
                    <p className="current__name">{data.name}</p>
                    {
                        data.info != 'Не указано' &&
                        <p className="current__info">Отделка: {data.info}</p>
                    }
                    <p className="current__floor">
                        {data.floor}, {types[currentRoom.type]}. №{data.number}
                    </p>
                </div>
            </div>
            <div className="current__description">
                {data.room !== 0 && <div className="current__data">
                    <p className="current__number">{data.room === 100 ? 'Студия' : data.room}</p>
                    <p className="current__what">комнаты</p>
                </div>
                }
                <div className="current__data">
                    <p className="current__number">{data.square}</p>
                    <p className="current__what">кв.м</p>
                </div>
                {
                    data.status == "Свободно" && !!data.show_price &&
                    <div className="current__data">
                        <p className="current__number">{data.price}</p>
                        <p className="current__what">рублей</p>
                    </div>
                }
            </div>
            <div className="current__variant"></div>
            <div className="current__text-block">
                <h3 className="current__h3">{data.title}</h3>
                <p className="current__text">
                    {
                        data.text &&
                        data.text.split('\n').map((item, key) => {
                            return <span key={key}>{item}<br/></span>
                        })
                    }
                </p>
                <h3 className="current__h3">{data.advantages}</h3>
                <ul className="current__list">
                    {
                        data.list &&
                        data.list.map((item) => (
                            <li className="current__item">{item}</li>
                        ))
                    }
                </ul>
            </div>
        </div>
        </div>
        </>
    );
}
